module.exports = __webpack_public_path__ + "static/media/EYInterstate-Regular.18028b40.svg";